import { FacebookIcon, PinterestIcon, PinterestShareButton, TwitterIcon } from "react-share";

import PropTypes from "prop-types";
import React, { useState } from "react";
import copy from "../../images/copy.png";
import { toast } from "react-toastify";
import axios from "axios";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";


function getSharerApi() {
  // Returns share API
  let currentUri = window.location.protocol + "//" + window.location.host + window.location.pathname;
  const lastSlashIndex = currentUri.length - 1;

  if (currentUri.charAt(lastSlashIndex) === "/") {
    currentUri = currentUri.slice(0, -1);
  }

  // noinspection SpellCheckingInspection
  currentUri = currentUri.replace("messier", "");

  return currentUri + "api/";
}

export function SocialShare(props: any) {

  const sharerApi = getSharerApi();
  const [sharableUrl, setSharableUrl]: any = useState(null);
  let time = new Date().toISOString().slice(0, 10);
  let fbEncoded: any = null;
  let twitterEncoded: any = null;

  if (sharableUrl) {
    fbEncoded = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(sharableUrl);
    twitterEncoded = "https://twitter.com/share?url=" + encodeURIComponent(sharableUrl);

  }

  const apiPayload = {
    title: props.mediaTitle,
    imageUrl: props.mediaUrl,
    cMName: props.c_m,
    url: props.url,
    description: props.mediaQuote,
  };
  if (props?.c_m !== "") {
    axios.post(sharerApi, apiPayload)
      .then(res => {
        setSharableUrl(res.data.url + "?q=" + time);
      })
      .catch(err => {
        console.warn(err);
      });
  }


  const copyMessage = (val: string) => {
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
    toast.success("Link copied!");
  };

  // @ts-ignore
  return (
    <>
      {!sharableUrl &&
      <Loader
        type="ThreeDots"
        color="grey"
        height={80}
        width={50}
        timeout={10000}

      />}
      {sharableUrl &&
      <>
        <a
          target="_blank"
          href={twitterEncoded}
          className="twitter-share-button"
          rel="noopener noreferrer"
          data-show-count="false"
        >
          <TwitterIcon size={32} round={true} />
        </a>
        <a
          target="_blank"
          href={fbEncoded}
          rel="noopener noreferrer"
          className="fb-xfbml-parse-ignore"
        >
          <FacebookIcon size={32} round={true} />
        </a>
        <PinterestShareButton url={props.url} media={props.mediaUrl} description={props.mediaQuote}>
          <PinterestIcon size={32} round={true} />
        </PinterestShareButton>
        <img className="im"
             src={copy} title="Copy to clipboard"
             id="copy_button"
             onClick={() => {
               copyMessage(props.url);
             }}
             alt={"copy-url"} />
      </>
      }

    </>
  );
}

SocialShare.prototype = {
  url: PropTypes.string,
  mediaUrl: PropTypes.string,
  mediaQuote: PropTypes.string,
  mediaTitle: PropTypes.string,
};
export default SocialShare;
